import reducer from './entity'

export default reducer
